export default "__VITE_ASSET__CGbCmIMo__"